<script lang="ts">
	import { getClient, query } from 'svelte-apollo';
	import { onMount } from 'svelte';
	import SmuiButton, { Label as SmuiLabel } from '@smui/button/styled';
  import { numToRedGreen } from '../../utils';
	import Select from 'svelte-select';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import Text from '../../components/Text.svelte';
	import GraphErrorList from '../../components/GraphQL/GraphErrorList.svelte';
	import { getFileContentInterestsQuery, getPersonaExplorerSocDemo, getPersonaExplorerInterests } from '../../graphql/queries/interests';

	let loading = false;
	let table: any = [],
		age_table: any,
		interests_table: any;
	let interestValues = [];
  let socdemoValues = [];
	let errorList: string[];
	let selectedInterest: { label: string; value: string };
	let moreHigh = 3;
	let moreHigh2 = 3;
  let selectItems = [];

	const client = getClient();

	const getFileContentOp = query(client, { query: getFileContentInterestsQuery });
  const getSocDemo = query(client, { query: getPersonaExplorerSocDemo});
  const getInterests = query(client, { query: getPersonaExplorerInterests});

	const getDataFetch = async () => {
		loading = true;
		errorList = undefined;
		try {
			const { data } = await getFileContentOp.refetch();
      console.log(data)
			table = data.getInterestContent;
		} catch (error) {
			errorList = error.graphQLErrors;
		}

		loading = false;
	};

  const getSocDemoFetch = async () => {
    loading = true;
    errorList = undefined;
    try {
      const { data } = await getSocDemo.refetch();
      console.log(data)
      age_table = data.getPersonaExplorerSocdemo;
    } catch (error) {
      errorList = error.graphQLErrors;
    }

    loading = false;
  };

  const getInterestsFetch = async () => {
    loading = true;
    errorList = undefined;
    try {
      const { data } = await getInterests.refetch();
      interests_table = data.getPersonaExplorerInterests;
    } catch (error) {
      errorList = error.graphQLErrors;
    }

    loading = false;
  };

	onMount(async () => {
		await getDataFetch();
    await getSocDemoFetch();
    await getInterestsFetch();
	});

  $: {
    selectItems = table.map((item: any) => {
      return {value: item.TPDmpId, label: item.account}
    });
  }

  $: {
    if (typeof selectedInterest !== "undefined") {
      console.log(selectedInterest)
      interestValues = interests_table.filter(function(item: any) {
        return item.targetId === (selectedInterest.value + "," + item.clientLabel);
      });
      socdemoValues = age_table.filter(function(item: any) {
        return item.targetId === (selectedInterest.value + "," + item.clientLabel);
      })
    }
  }

  function styleValueCell(cellValue: any, all_values: any) {
    all_values = all_values.sort(function (a: number, b: number) {return a - b});
    const valueIndex = all_values.indexOf(cellValue);
    if (valueIndex >= 0) {
      const color = numToRedGreen(valueIndex / all_values.length, 0.55);
      return `background-color: ${color}`;
    }
  }

  function roundCellNumber(possibleNumber: string, decimalPoints = 2) {
    const cellInt = parseFloat(possibleNumber);
    if (cellInt) {
      const decQuoc = 10 ** decimalPoints;
      return Math.floor(cellInt * decQuoc) / decQuoc;
    }
    return possibleNumber;
  }

</script>

<AppContainer style="position:relative;">
	{#if loading}
		<LoadingOverlay title="Loading..." spinner />
	{/if}
	{#if table}
		<Text type="headline4">Please select Key Interaction</Text>
		<div class="flex">
			<div style="width: 150px; margin-left: 15px;">
				<Select
					selectedValue={selectedInterest}
					items={selectItems}
					on:select={(e) => {
						selectedInterest = e.detail;
						//onSelectChange();
					}}
				/>
			</div>
		</div>
	{/if}
  {#if typeof selectedInterest != "undefined" && interestValues.length > 0}
    <div class="flex responsive last">
      <div class="left">
        <Text type="headline5">High Affinity Interests</Text>
        <br />
        <table>
          <tbody>
            {#each interestValues.sort(function (a,b) { return b.coefficient - a.coefficient}).filter((item, idx) => item && idx < moreHigh) as valWName}
              {#if valWName.coefficient > 0 && valWName.coefficient !== null}
                <tr>
                  <td>{valWName.interestName}</td>
                  <td style={styleValueCell(valWName.coefficient, interestValues.sort(function (a,b) { return b.coefficient - a.coefficient}).map((item) => item.coefficient))}
                    >{roundCellNumber(valWName.coefficient)}</td
                  >
                </tr>
              {/if}
            {/each}
            {#if interestValues.filter(function(item) {return item.coefficient > 0 && item.coefficient !== null}).length >= moreHigh}
              <div class="more-button">
                <SmuiButton on:click={() => {
                  moreHigh += 3;
                }} variant="raised">
                  <SmuiLabel>More</SmuiLabel>
                </SmuiButton>
              </div>
            {/if}
          </tbody>
        </table>
      </div>
      <div class="right">
        <Text type="headline5">Low Affinity Interests</Text>
        <br />
        <table>
          <tbody>
          {#each interestValues.sort(function (a,b) { return a.coefficient - b.coefficient}).filter((item, idx) => item && idx < moreHigh2) as valWName}
            {#if valWName.coefficient < 0 && valWName.coefficient !== null}
              <tr>
                <td>{valWName.interestName}</td>
                <td style={styleValueCell(valWName.coefficient, interestValues.sort(function (a,b) { return a.coefficient - b.coefficient}).map((item) => item.coefficient))}
                >{roundCellNumber(valWName.coefficient)}</td
                >
              </tr>
            {/if}
          {/each}
          {#if interestValues.filter(function(item) {return item.coefficient < 0 && item.coefficient !== null}).length >= moreHigh2}
            <div class="more-button">
              <SmuiButton on:click={() => {
                  moreHigh2 += 3;
                }} variant="raised">
                <SmuiLabel>More</SmuiLabel>
              </SmuiButton>
            </div>
          {/if}
          </tbody>
        </table>
      </div>
    </div>
    {/if}
  {#if typeof selectedInterest != "undefined" && socdemoValues.length > 0}
    <div class="flex responsive last">
      <div class="left">
        <Text type="headline5">Age Affinity</Text>
        <br />
        <table>
          <tbody>
          {#each socdemoValues.sort(function (a,b) { return a.socDemoId.replace("ageGroup_", "").charAt(0) - b.socDemoId.replace("ageGroup_", "").charAt(0)}) as valWName}
            {#if valWName.socDemoId !== "male" && valWName.socDemoId !== "female" && valWName.socDemoId !== "ageGroup_0-17"}
              <tr>
                <td>{valWName.socDemoId.replace("ageGroup_", "")}</td>
                <td style={styleValueCell(valWName.value, socdemoValues.sort(function (a,b) { return b.coefficient - a.coefficient}).map((item) => item.value))}
                >{roundCellNumber(valWName.value)}</td
                >
              </tr>
            {/if}
          {/each}
          </tbody>
        </table>
      </div>
      <div class="right">
        <Text type="headline5">Gender Affinity</Text>
        <br />
        <table>
          <tbody>
          {#each socdemoValues.sort(function (a,b) { return a.socDemoId.localeCompare(b.socDemoId)}) as valWName}
            {#if valWName.socDemoId === "male" || valWName.socDemoId === "female"}
              <tr>
                <td>{valWName.socDemoId}</td>
                <td style={styleValueCell(valWName.value, socdemoValues.sort(function (a,b) { return b.coefficient - a.coefficient}).map((item) => item.value))}
                >{roundCellNumber(valWName.value)}</td
                >
              </tr>
            {/if}
          {/each}
          </tbody>
        </table>
      </div>
    </div>
      {/if}

	<GraphErrorList {errorList}>
		<p>Data not available for client</p>
	</GraphErrorList>
</AppContainer>

<style>
	table {
		border-spacing: 0;
	}

	td {
		border-bottom: 1px solid #999;
		border-right: 1px solid hsla(0, 0%, 100%, 0.67);
		min-width: 40px;
	}

	td:first-of-type {
		min-width: 200px;
		width: 200px;
		padding-left: 8px;
		line-height: 1;
	}
	td:nth-of-type(n + 2) {
		text-align: right;
		padding: 14px 10px;
	}

	tbody tr:hover {
		background-color: #00000020;
	}

	.flex {
		display: flex;
		flex-direction: row;
		margin-top: 24px;
		align-items: center;
	}

	.flex.responsive {
		flex-direction: column;
	}

	@media screen and (min-width: 600px) {
		.flex.responsive {
			flex-direction: row;
		}
	}
	.left,
	.right {
		padding: 12px 24px 12px 0;
	}
	.more-button {
		padding-top: 20px;
		display: flex;
		align-items: center;
	}

	.flex.last {
		align-items: flex-start;
	}

	:global(.select-fixed-width) {
		width: 150px;
	}
</style>
